import axios from "axios";
import { refreshToken } from "../helpers/RequestExecutor";

export const startRound = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/round/start`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data;
    } catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await startRound();
        } else {
            return e.response.data;
        }
    }
}

export const getRoundLogs = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/round/logs`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data;
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await getRoundLogs();
        } else {
            return e.response.data;
        }
    }
}

export const applyShareSuspend = async (company) => {
    const body = {};
    if (!company) body.pass = true;
    else body.stock = company;
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/round/share-suspend`, body, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data;
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await applyShareSuspend(company);
        } else {
            return e.response.data;
        }
    }
}